import {Action} from "@ngrx/store";

export const LOAD_BOOSTER_ADVANCED_SETTINGS: string = '[website] Load Booster Advanced Settings';
export const LOAD_BOOSTER_ADVANCED_SETTINGS_SUCCESS: string = '[website] Load Booster Advanced Settings Success';
export const LOAD_BOOSTER_ADVANCED_SETTINGS_FAIL: string = '[website] Load Booster Advanced Settings Fail';

export class LoadBoosterAdvancedSettings implements Action {
  readonly type: string = LOAD_BOOSTER_ADVANCED_SETTINGS;
  constructor(public payload: number) {}
}

export class LoadBoosterAdvancedSettingsSuccess implements Action {

  readonly type: string = LOAD_BOOSTER_ADVANCED_SETTINGS_SUCCESS;
  constructor(public payload: {
    websiteId: number,
    entities: {[websiteId: number]: any},
  }) {}

}

export class LoadBoosterAdvancedSettingsFail implements Action {

  readonly type: string = LOAD_BOOSTER_ADVANCED_SETTINGS_FAIL;
  constructor(public payload: { websiteId: number}) {}

}


export type BoosterAdvancedSettingsAction = LoadBoosterAdvancedSettings | LoadBoosterAdvancedSettingsSuccess | LoadBoosterAdvancedSettingsFail;
